/**
 * BADU — product page enhancements
 *
 * 1. Read more / read less on the description.
 * 2. Mirrors the chosen size into the option legend, so it reads "SIZE  M"
 *    rather than just "SIZE".
 *
 * Both are progressive: with the script blocked, the description is fully
 * readable and the legend still names the option.
 */
(function () {
  /* ---------------------------------------------------------------- read more */

  function initReadMore(scope) {
    for (const root of scope.querySelectorAll('[data-badu-readmore]')) {
      if (root.dataset.baduReadmoreBound === 'true') continue;
      root.dataset.baduReadmoreBound = 'true';

      const body = root.querySelector('[data-badu-readmore-body]');
      const toggle = root.querySelector('[data-badu-readmore-toggle]');
      const label = root.querySelector('[data-badu-readmore-label]');
      if (!body || !toggle || !label) continue;

      const sign = root.querySelector('[data-badu-readmore-sign]');
      const more = label.textContent.trim();
      const less = root.dataset.baduLessLabel || 'Read less';

      // Clamp first, then compare: if the copy is short enough to fit there is
      // nothing to expand, so the control stays hidden rather than lying.
      root.classList.add('is-clamped');

      const overflows = body.scrollHeight - body.clientHeight > 4;
      if (!overflows) {
        root.classList.remove('is-clamped');
        continue;
      }

      toggle.hidden = false;

      toggle.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        root.classList.toggle('is-clamped', !expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        label.textContent = expanded ? less : more;
        // A rotated plus reads as a cross; use the actual minus sign.
        if (sign) sign.textContent = expanded ? '−' : '+';
      });
    }
  }

  /* ------------------------------------------------- selected option in legend */

  function initOptionLabels(scope) {
    for (const fieldset of scope.querySelectorAll('.variant-option')) {
      const legend = fieldset.querySelector('legend');
      if (!legend) continue;

      let value = legend.querySelector('.badu-option-value');
      if (!value) {
        value = document.createElement('span');
        value.className = 'badu-option-value';
        legend.appendChild(value);
      }

      const sync = () => {
        const checked = fieldset.querySelector('input:checked');
        value.textContent = checked ? checked.value : '';
      };

      if (fieldset.dataset.baduOptionBound !== 'true') {
        fieldset.dataset.baduOptionBound = 'true';
        fieldset.addEventListener('change', sync);
      }
      sync();
    }
  }

  function init(root) {
    const scope = root instanceof Element ? root : document;
    initReadMore(scope);
    initOptionLabels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  // Horizon re-renders the details column when a variant changes, and the
  // theme editor swaps whole sections.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('variant:update', () => init(document));
})();
